export default __webpack_public_path__ + "static/media/Foto Virtual conference.8477d015.png";